import 'regenerator-runtime/runtime';
import utils from '@bigcommerce/stencil-utils';
import $ from 'jquery';

export default function (context) {

	function updateAlternateItems(ids) {
		const fetchContent = [];
		let ul = $("<ul>", {"class": "productList"})
		for (let productId of ids) {
            utils.api.product.getById(productId, { template: 'products/alternate-item' }, (err, response) => {
        		if (err) return;

        		let li = $("<li>", {"class": "product"}).append(response);
        		ul.append(li);
        	});
		}

		$('#alternate-items').append(ul);
	}

	// async function updateAlternateItems(skus) {
	// 	const fetchContent = [];
	// 	let ul = $("<ul>", {"class": "productList"})
	// 	for (let sku of skus) {
	// 		fetchContent.push(
	// 			fetch('/graphql', {
	// 	            method: 'POST',
	// 	            credentials: 'same-origin',
	// 	            headers: {
	// 	                'Content-Type': 'application/json',
	// 	                'Authorization': 'Bearer ' + context.settings.storefront_api.token
	// 	            },
	// 	            body: JSON.stringify({
	// 	                query: `
	// 	                query getIdBySku {
	// 	                    site {
	// 	                    product (sku: \"` + sku + `\") {
	// 	                        entityId
	// 	                    }
	// 	                  }
	// 	                }
	// 	                `
	// 	            }),
	// 	        })
	// 	        .then(res => res.json())
	// 	        .then(json => {
	// 	            if (json.data.site.product) {
	// 	                console.log(json.data.site.product.entityId);
	// 	                let productId = json.data.site.product.entityId;
	// 	                utils.api.product.getById(productId, { template: 'products/alternate-item' }, (err, response) => {
	// 	            		if (err) return;

	// 	            		let li = $("<li>", {"class": "product"}).append(response);
	// 	            		ul.append(li);
	// 	            	});
	// 	            }
	// 	        })
	// 	    )
	// 	}
	// 	await Promise.all(fetchContent);

	// 	$('#alternate-items').append(ul);
	// }

	function isRunningInIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

	function redirectTo(url) {
        if (isRunningInIframe() && !window.iframeSdk) {
            window.top.location = url;
        } else {
            window.location = url;
        }
    }

    if (context.music_video_product === 1 && context.mpn) {
		let split = context.mpn.split('-');
		let type = split.pop();
        const groupId = ['V', 'L', 'VL'];
        if (type == 'L' || type == 'VL') {
        	let mainSku = split[1];
        	fetch('/graphql', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + context.settings.storefront_api.token
                },
                body: JSON.stringify({
                    query: `
                    query getIdBySku {
                        site {
                        product (sku: \"` + mainSku + `\") {
                            entityId
                            path
                        }
                      }
                    }
                    `
                }),
            })
            .then(res => res.json())
            .then(json => {
                if (json.data.site.product) {
                    let productId = json.data.site.product.entityId;
                    let path = json.data.site.product.path;

                    redirectTo(path)
                }
            })
        }
    }

	// fetch product data, fill in alternate items content
	if ($('#alternate-items-value').val()) {
		let ids = $('#alternate-items-value').val().split(',');

		updateAlternateItems(ids);
	}
}
